<template>
  <div>
    <!-- <Hedaers /> -->
    <el-carousel style="width: 100%" height="300px" direction="vertical" class="carousel" :autoplay="false">
      <el-carousel-item v-for="item in bannerList" :key="item.id">
        <el-image :src="item.picUrl" alt="" style="width: 100%; height: 100%" />
      </el-carousel-item>
    </el-carousel>
    <div class="content">
      <!-- <div class="content_title">
        <div class="content_title_left"><span>在线下单</span></div>
        <div class="content_title_right">
          <div>每天寄件超过50单，建议 <span>批量下单</span> 效率更高</div>
        </div>
      </div> -->
      <div class="tab_content">
        <div class="form_data">
          <el-form ref="form" :model="form" label-width="140px" :rules="rules">
            <el-row :gutter="20">
              <el-col :span="24">
                <!-- <div class="form_title_box">
                  <div class="form_title_left">
                    <img class="form_title_icon" :src="require('@/assets/img/order_title_1.png')" alt="">
                    <span class="form_title_text">寄件信息</span>
                  </div>
                  <div class="form_title_right" @click.stop="openAddress">
                    <img :src="require('@/assets/img/postion.png')" alt="">
                    <span>常用地址簿</span>
                  </div>
                </div> -->
                <div class="form_title_box">
                  <div class="form_title_left">
                    <img class="form_title_icon" :src="require('@/assets/img/order_title_1.png')" alt="">
                    <span class="form_title_text">寄件信息</span>
                  </div>
                  <div class="form_title_right">
                    <div class="form_title_btn" @click="openSmart('sender')">
                      <span>辅助填写</span>
                    </div>
                    <div class="form_title_btn" @click="openAddress">
                      <img :src="require('@/assets/img/postion.png')" alt="">
                      <span>常用地址簿</span>
                    </div>
                  </div>
                </div>
                <el-row :gutter="10" style="margin-bottom:70px">
                  <el-col :span="8">
                    <el-form-item label="托运单位：" prop="senderCompanyName">
                      <el-input v-model.trim="form.senderCompanyName
                        " placeholder="请输入托运单位" maxlength="50"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="发货人：" prop="senderName">
                      <!-- <el-input v-model.trim="form.senderName" placeholder="请输入发货人" maxlength="50"></el-input> -->
                      <el-autocomplete v-model="form.senderName" style="width: 100%;" value-key="name" :fetch-suggestions="senderQuerySearch"
                        placeholder="请输入发货人" :maxlength="50" @select="handleSelect">
                      </el-autocomplete>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="手机号码：" prop="senderTel">
                      <el-input v-model.trim="form.senderTel" placeholder="请输入手机号码" maxlength="40"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="固定电话：" prop="senderFixed">
                      <el-input v-model="form.senderFixed" placeholder="请输入固定电话" maxlength="20"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="发货地址：" prop="selectSenderAera">
                      <el-cascader :props="{
                        value: 'code',
                        label: 'name',
                      }" :options="areaList" v-model="form.selectSenderAera" style="width: 100%" placeholder="请选择">
                      </el-cascader>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="详细地址：" prop="senderAddress">
                      <el-input v-model="form.senderAddress" placeholder="请输入详细地址" maxlength="255"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="24">
                <!-- <div class="form_title">
                  <img class="form_title_icon" :src="require('@/assets/img/order_title_2.png')" alt="">
                  <span class="form_title_text">收件信息</span>
                </div> -->
                <div class="form_title_box">
                  <div class="form_title_left">
                    <img class="form_title_icon" :src="require('@/assets/img/order_title_2.png')" alt="">
                    <span class="form_title_text">收件信息</span>
                  </div>
                  <div class="form_title_btn_list">
                    <div class="form_title_btn" @click="getExportExcl" style="margin-right: 12px;">
                      <span style="color: #FF8A00;">下载模版</span>
                    </div>
                    <div class="form_title_btn" style="background-color: #FF8A00">
                      <el-upload
                        :auto-upload="true"
                        :file-list="fileList"
                        ref="upload"
                        action="#"
                        :show-file-list="false"
                        :http-request="() => {}"
                        :before-upload="beforeUpload"
                        name="file"
                      >
                        <span style="color: #fff;">选取文件</span>
                      </el-upload>
                    </div>
                  </div>

                </div>
                <el-row :gutter="10" style="margin-bottom:70px">
                  <div style="font-size: 14px; color: #333;font-weight: 500;margin-bottom: 12px;"><span>已成功上传的收件人列表：</span></div>
                    <el-table style="width: 100%" :data="tableData">
                      <el-table-column align="center" width="50" type="index" label="编号"></el-table-column>
                      <el-table-column align="center" width="140" label="收件人姓名" prop="receiverName"></el-table-column>
                      <el-table-column align="center" width="140" label="收件人手机" prop="receiverTel"></el-table-column>
                      <el-table-column align="center" width="140" label="收件人固话" prop="receiverFixed"></el-table-column>
                      <el-table-column align="center" width="140" label="收件人公司" prop="receiverCompanyName"></el-table-column>
                      <el-table-column align="center" width="280" label="省市区(县)详细地址">
                        <template slot-scope="scope">
                          {{ scope.row.receiverProvinceSpan }}{{ scope.row.receiverAreaSpan }}{{ scope.row.receiverCitySpan }}{{ scope.row.receiverAddress }}
                        </template>
                      </el-table-column>
                      <el-table-column align="center" width="340" label="期望上门时间">
                        <template slot-scope="scope">
                          {{ scope.row.timeStart }}至{{ scope.row.timeEnd }}
                        </template>
                      </el-table-column>
                      <el-table-column align="center" width="140" label="物品名称" prop="name"></el-table-column>
                      <el-table-column align="center" width="140" label="件数" prop="qty"></el-table-column>
                      <el-table-column align="center" width="140" label="重量(KG)" prop="weight"></el-table-column>
                      <el-table-column align="center" width="140" label="体积(m²)" prop="volume"></el-table-column>
                      <el-table-column align="center" width="140" label="付款方式" prop="payTypeSpan"></el-table-column>
                      <el-table-column align="center" width="140" label="送货方式" prop="deliveryTypeSpan"></el-table-column>
                      <el-table-column align="center" width="140" label="代收货款" prop="amountCollected"></el-table-column>
                      <el-table-column align="center" width="140" label="是否等通知放货" prop="releaseCargoTypeSpan"></el-table-column>
                      
                      <!-- <el-table-column align="center" label="操作" fixed="right" width="140"></el-table-column> -->
                    </el-table>
                </el-row>

                <!-- <el-row :gutter="10" style="margin-bottom:70px">
                  <el-col :span="8">
                    <el-form-item label="收货单位：" prop="receiverCompanyName">
                      <el-input v-model="form.receiverCompanyName
                        " placeholder="请输入收货单位" maxlength="50"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="收货人：" prop="receiverName">
                      <el-input v-model.trim="form.receiverName" placeholder="请输入收货人" maxlength="50"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="手机号码：" prop="receiverTel">
                      <el-input v-model.trim="form.receiverTel" maxlength="11" placeholder="请输入手机号码"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="固定电话：" prop="receiverFixed">
                      <el-input v-model.trim="form.receiverFixed
                        " placeholder="请输入固定电话" maxlength="20"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="收货地址：" prop="selectReceiverAera">
                      <el-cascader :props="{
                        value: 'code',
                        label: 'name',
                      }" :options="areaList" v-model="form.selectReceiverAera
                        " style="width: 100%" placeholder="请选择">
                      </el-cascader>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="详细地址：" prop="receiverAddress">
                      <el-input v-model="form.receiverAddress" placeholder="请输入详细地址" maxlength="255"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row> -->
              </el-col>
              <!-- <el-col :span="24">
                <div class="form_title">
                  <img class="form_title_icon" :src="require('@/assets/img/order_title_3.png')" alt="">
                  <span class="form_title_text">货物信息</span>
                </div>
                <el-row :gutter="10" style="margin-bottom:70px">
                  <el-col :span="8">
                    <el-form-item label="货物名称：" prop="name">
                      <el-input v-model.trim="form.name" placeholder="请输入" maxlength="50"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="件数：" prop="qty">
                      <el-input v-model.number="form.qty" placeholder="请输入" maxlength="7"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="总体积(方)：" prop="volumeRel">
                      <el-input v-model.trim="form.volumeRel" placeholder="请输入实际体积" maxlength="9"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="总重量(千克)：" prop="weightRel">
                      <el-input v-model.trim="form.weightRel" placeholder="请输入实际体积" maxlength="9"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
              <el-col :span="24">
                <div class="form_title">
                  <img class="form_title_icon" :src="require('@/assets/img/order_title_4.png')" alt="">
                  <span class="form_title_text">其他服务</span>
                </div>
                <el-row :gutter="10" style="margin-bottom:40px">
                  <el-col :span="8">
                    <el-form-item label="送货方式：" prop="deliveryType">
                      <el-select placeholder="请选择" v-model="form.deliveryType" style="width: 100%">
                        <el-option v-for="item in sendTypeList" :key="item.value" :label="item.name"
                          :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="付款方式：" prop="payType">
                      <el-select placeholder="请选择" v-model="form.payType" style="width: 100%">
                        <el-option v-for="item in payTypeList" :key="item.value" :label="item.name" :value="item.value">
                        </el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="是否等通知放货：" prop="releaseCargoType">
                      <el-select placeholder="请选择" v-model="form.releaseCargoType" style="width: 100%">
                        <el-option label="否" :value="0"></el-option>
                        <el-option label="是" :value="1"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="8">
                    <el-form-item label="代收货款：" prop="amountCollected">
                      <el-input v-model.number="form.amountCollected
                        " placeholder="请输入" maxlength="9"></el-input>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col> -->
            </el-row>
          </el-form>
          <div class="check_box">
            <el-checkbox v-model="checked">阅读并同意</el-checkbox>
            <span @click="openClause">《运单契约条款》</span>
          </div>
          <div class="bottom_btn"><el-button class="bottom_btn_item" v-loading="editLoading"  @click="submitForm">提交运单</el-button></div>
        </div>
        <!-- 物流查询 -->
        <!-- <div class="search_content">
                    <div class="search_box">
                        <el-input
                            v-model.trim="orderNumber"
                            size="small"
                            style="width: 94%; margin-right: 10px"
                            placeholder="请输入运单号进行查询"
                        ></el-input>
                        <el-button size="small" type="primary" @click="getDeatail">查询</el-button>
                    </div>
                    <div class="destination" v-if="orderDetail">
                        <div class="destination_left">{{orderDetail.sendCity}}</div>
                        <img :src="require('@/assets/freight.png')" alt="" />
                        <div class="destination_right">{{orderDetail.receiverCity}}</div>
                    </div>
                    <el-timeline v-if="orderDetail">
                        <el-timeline-item
                            v-for="(activity, index) in orderDetail.details"
                            :key="index"
                        >
                            <div class="timeline_item">
                                <div class="timeline_item_time">
                                    {{ activity.createTimeSpan }} <span style="margin-left:10px;">{{activity.statusSpan}}</span>
                                </div>
                                <div class="timeline_item_content">
                                    {{ activity.content }}
                                </div>
                            </div>
                        </el-timeline-item>
                    </el-timeline>
                </div> -->
      </div>
    </div>
    <UserAddress ref="userAddressRef"   @change="addressChange" />
    <Clause ref="clauseRef" />
    <SmartParsePro :visible="smartVisible" :type="this.smartType" @close="closeSmart" @submitData="getAddressInfo" />
  </div>
</template>

<script>
import { getAreaSelect, getInfo, getSendType, getPayType, add, search, banner,addressList,uploadGoods,batchOrderSave } from "@/api/home";
import { getDefault } from "@/api/order";
import { JsonDownload } from '@/utils/auth'
import UserAddress from '@/components/UserAddress.vue'
import Hedaers from "../hedaer/index.vue";
import Clause from '@/components/Clause.vue'
import SmartParsePro from '@/components/smartParsePro.vue';
export default {
  metaInfo: {
    title: '京递快运官网 - 批量下单', // set a title
    meta: [{             // set meta
      name: 'keyWords',
      content: '京递快运官网 - 批量下单'
    },
    {
      name: 'description',
      content: '京递 是拥有十五年[互联网十物流]团队创办大货品类快运公司。在扎实的商流驱动物流的远景规划中，以互连互通数智化去拥抱电商市场进军大货快运赛道。以超强的互联网速度和过硬的IT技术，体验中国智造消费流通的便利，高度重视[客户体验]的基础上，顶层追求大货集运。以稳定十时效十温度，通过数字化整合国内网点，完成大货时效保障，踏实极致的塑造伙伴可信赖的供应商。'
    }
    ],
  },
  name: "batchOrder",
  components: { Hedaers,UserAddress,Clause,SmartParsePro },
  data() {
    return {
      checked:false,
      tabList: [
        {
          label: "在线下单",
          id: 0,
        },
        {
          label: "货物追踪",
          id: 1,
        },
      ],
      selectIndex: 0,
      form: {
        // receiverCompanyName: null,
        // receiverName: null,
        // receiverTel: null,
        // receiverFixed: null,
        // selectReceiverAera: null,
        // receiverAddress: null,

        senderCompanyName: null,
        senderName: null,
        senderTel: null,
        senderFixed: null,
        selectSenderAera: null,
        senderAddress: null,
        goods:[]
        // name: null,
        // qty: null,
        // weightRel: null,
        // volumeRel: null,
        // deliveryType: null,
        // releaseCargoType: null,
        // payType: null,
        // amountCollected: null,
      },
      areaList: [],
      orderNumber: null,
      activities: [
        {
          content: "活动按期开始",
          timestamp: "2018-04-15",
        },
        {
          content: "通过审核",
          timestamp: "2018-04-13",
        },
        {
          content: "创建成功",
          timestamp: "2018-04-11",
        },
      ],
      sendTypeList: [], //配送方式列表
      payTypeList: [], //付款方式列表
      rules: {
        senderName: [
          {
            required: true,
            message: "请输入发货人",
            trigger: "change",
          },
        ],
        receiverName: [
          {
            required: true,
            message: "请输入收货人",
            trigger: "change",
          },
        ],
        senderTel: [
          {
            required: true,
            message: "请输入发货人手机号码",
            trigger: "change",
          },
          // {
          //   pattern: /^[0-9]*$/,
          //   message: "请输入正确的手机号码",
          // },
        ],
        receiverTel: [
          {
            required: true,
            message: "请输入收货人手机号码",
            trigger: "change",
          },
          // {
          //   pattern: /^[0-9]*$/,
          //   message: "请输入正确的手机号码",
          // },
        ],
        selectSenderAera: [
          {
            required: true,
            message: "请选择发货地址",
            trigger: "change",
          },
        ],
        selectReceiverAera: [
          {
            required: true,
            message: "请选择收货地址",
            trigger: "change",
          },
        ],
        senderAddress: [
          {
            required: true,
            message: "请输入发货详细地址",
            trigger: "change",
          },
        ],
        receiverAddress: [
          {
            required: true,
            message: "请输入收货详细地址",
            trigger: "change",
          },
        ],
        name: [
          {
            required: true,
            message: "请输入货物名称",
            trigger: "change",
          },
        ],
        qty: [
          {
            required: true,
            message: "请输入物品件数",
            trigger: "change",
          },
        ],
        deliveryType: [
          {
            required: true,
            message: "请选择配送方式",
            trigger: "change",
          },
        ],
        releaseCargoType: [
          {
            required: true,
            message: "请选择是否等通知放货",
            trigger: "change",
          },
        ],
        payType: [
          {
            required: true,
            message: "请选择付款方式",
            trigger: "change",
          },
        ],
        isCollected: [
          {
            required: true,
            message: "请选择是否有代收货款",
            trigger: "change",
          },
        ],
        // amountCollected: [
        //     {
        //         required: true,
        //         message: "请输入代收货款金额",
        //         trigger: "change",
        //     },
        // ],
      },
      orderDetail: null,
      bannerList: [
        {
          picUrl: require('@/assets/img/order_banner.png')
        },
      ],
      isSave: false,
      fileList:[],
      tableData:[],
      editLoading:false,
      smartVisible: false,
      smartType: 'sender',// sender = 寄件 recipients = 收件
      senderList:[]

    };
  },
  created() {
    // this.gerBanner();
  },
  mounted() {
    // console.log()
    this.getAreaList();
    this.getSendTypeList();
    this.getPayTypeList();
    this.getAddressList();
    getDefault({}).then(response => {
      if(response.data){
        let val = response.data;
        this.form.selectSenderAera = [val.province,val.city,val.county];
        this.form.senderAddress = val.address || null;
        this.form.senderName = val.name || null;
        this.form.senderTel = val.mobilePhone || null;
        this.form.senderFixed = val.fixedPhone || null;
        this.form.senderCompanyName = val.companyName || null;
        this.form.senderId = val.id || null;
      }
    });
    // this.getDeatail();
  },
  methods: {
    gerBanner() {
      banner({ dataType: 2, status: 1 }).then(response => {
        if (response.code == 200) {
          this.bannerList = response.data;
        }
      })
    },
    // 获取省市区分离地址
    // 获取省市区地址
    getAreaList() {
      getAreaSelect({}).then((response) => {
        this.areaList = response.data;
      });
    },
    getDeatail() {
      if (!this.orderNumber) return this.$message.warning('请输入运单编号进行查询');
      search({}, this.orderNumber).then(response => {
        if (response.code == 200) {
          this.orderDetail = response.data;
        }
      })
    },
    // 获取配送方式
    getSendTypeList() {
      getSendType({}).then((response) => {
        this.sendTypeList = response.data;
      });
    },
    // 获取支付方式
    getPayTypeList() {
      getPayType({}).then((response) => {
        this.payTypeList = response.data;
      });
    },
    tabClick(val, index) {
      // console.log(val);
      if (this.selectIndex == index) return false;
      if (this.selectIndex == 0) {
        this.cancelDataScope();
      }
      this.selectIndex = index;

    },
    submitForm() {
      this.$refs.form.validate((valid) => {
        console.log(this.form)
        if (valid) {
          if(this.checked === false) return this.$message.warning('请阅读并同意《运单契约条款》');
          this.setSubmit();
        }
      });
    },
    setSubmit() {
      this.editLoading = true;

      // this.form.receiverProvince = this.form.selectReceiverAera[0] || null;
      // this.form.receiverArea = this.form.selectReceiverAera[1] || null;
      // this.form.receiverCity = this.form.selectReceiverAera[2] || null;
      if(this.tableData.length == 0) return this.$message.warning('请导入收件人信息后再进行提交操作');
      this.form.senderProvince = this.form.selectSenderAera[0] || null;
      this.form.senderArea = this.form.selectSenderAera[1] || null;
      this.form.senderCity = this.form.selectSenderAera[2] || null;
      this.form.goods = this.tableData;
      console.log(this.form);
      batchOrderSave(this.form).then((response) => {
        this.editLoading = false;
        if (response.code == 200) {
          this.$message.success('下单成功');
          this.cancelDataScope();
        }
      })
        .catch(() => {
          this.editLoading = false;
        });
    },
    cancelDataScope() {
      this.form.receiverCompanyName = undefined;
      this.form.receiverName = undefined;
      this.form.receiverTel = undefined;
      this.form.receiverFixed = undefined;
      this.form.selectReceiverAera = undefined;
      this.form.receiverAddress = undefined;
      this.form.goods = [];
      this.tableData = [];
      setTimeout(() => {
        this.$refs["form"].clearValidate();
      }, 100);
      // this.$refs["form"].clearValidate();
      // this.$refs["form"].resetFields();

      // this.activeName = '0'
    },
    openAddress(){
      this.$refs.userAddressRef.open();
    },
    addressChange(val){
      console.log(val);
      this.form.selectSenderAera = [val.province,val.city,val.county];
      this.form.senderAddress = val.address || null;
      this.form.senderName = val.name || null;
      this.form.senderTel = val.mobilePhone || null;
      this.form.senderFixed = val.fixedPhone || null;
      this.form.senderCompanyName = val.companyName || null;
      this.form.senderId = val.id || null;
      // 多个订单多个物品
      let test = {
        senderName:'',//寄件人姓名
        senderTel:'',//寄件人手机号
        senderCompanyName:'',//寄件人公司名称
        senderFixed:'',//固定电话
        senderProvince:'',//省号
        senderArea:'',//市号
        senderCity:'',//区号
        senderAddress:'',//详细地址
        receiverList:[ //收件人列表
          {
            receiverCompanyName: null,//收件人公司名称
            receiverName: null,//收件人姓名
            receiverTel: null,//收件人电话
            receiverFixed: null,//收件人固话
            receiverProvince:'',//省号
            receiverArea:'',//市号
            receiverCity:'',//区号
            receiverAddress: null,//详细地址

            name:null,//物品名称
            qty:null,//件数
            volumeRel:null,//体积
            weightRel:null,//重量

            deliveryType:null,//配送方式
            payType:null,//付款方式
            releaseCargoType:null,//是否等通知放货
            amountCollected:null,//代收货款
          }
        ]
      }
      // 多个订单 一个物品 不同参数
      let test1 = {
        senderName:'',//寄件人姓名
        senderTel:'',//寄件人手机号
        senderCompanyName:'',//寄件人公司名称
        senderFixed:'',//固定电话
        senderProvince:'',//省号
        senderArea:'',//市号
        senderCity:'',//区号
        senderAddress:'',//详细地址
        receiverList:[ //收件人列表
          {
            receiverCompanyName: null,//收件人公司名称
            receiverName: null,//收件人姓名
            receiverTel: null,//收件人电话
            receiverFixed: null,//收件人固话
            receiverProvince:'',//省号
            receiverArea:'',//市号
            receiverCity:'',//区号
            receiverAddress: null,//详细地址

            qty:null,//件数
            volumeRel:null,//体积
            weightRel:null,//重量
          }
        ],
        name:null,//物品名称
        deliveryType:null,//配送方式
        payType:null,//付款方式
        releaseCargoType:null,//是否等通知放货
        amountCollected:null,//代收货款
      }
    },
    getExportExcl() {
      // if (!this.queryParams.createDate) {
      //   this.queryParams.createDate = ""
      // }
      JsonDownload(`/logisticsExpressage/goods/getTemp`, {
        // ...this.queryParams
      }, `收件信息模板_${new Date().getTime()}.xlsx`, 'get')
    },
    async submitUpload(){
      this.$refs.upload.submit();
    },
  beforeUpload(file){
    console.log(file);
    console.log(this.fileList);
    let formData = new FormData();
    formData.append('file',file);
    uploadGoods(formData).then(response => {
      if(response.code == 200){
        this.tableData = response.data;
      }
    })
  },
   handleFileUpload(fileObjcet){
      // console.log(file);
      console.log('456')
      // let formData = new FormData();
      // formData.append('file',fileObjcet.file);
      // try{
      //   let res = await uploadGoods(formData);
      //   console.log(res);
      // }catch{

      // }
    },
    openClause(){
      this.$refs.clauseRef.open();
    },
    openSmart(type) {
      this.smartVisible = true;
      this.smartType = type;
    },
    closeSmart() {
      this.smartVisible = false;
    },
    getAddressInfo(val, type) {
      if (type == 'sender') {
        if (val.provinceCode) {
          this.form.selectSenderAera = [val.provinceCode, val.cityCode, val.countyCode]
          this.form.senderAddress = val.address;
          this.form.senderTel = val.phone;
          this.form.senderName = val.name;
        }
      } else {
        if (val.provinceCode) {
          this.form.selectReceiverAera = [val.provinceCode, val.cityCode, val.countyCode]
          this.form.receiverAddress = val.address;
          this.form.receiverTel = val.phone;
          this.form.receiverName = val.name;
        }
      }
    },
    senderQuerySearch(queryString, cb) {
      var restaurants = this.senderList;
      var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    createFilter(queryString) {
      return (restaurant) => {
        return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },
    // 获取地址簿
    async getAddressList() {
      let senderList = await addressList({ searchWord: '', dataType: 1 });
      this.senderList = senderList.data;

    },
    // 选择发货人信息
    handleSelect(item) {
      this.$set(this.form, 'senderName', item.name);
      this.$set(this.form, 'senderTel', item.mobilePhone);
      this.$set(this.form, 'senderCompanyName', item.companyName);
      this.$set(this.form, 'senderAddress', item.address);
      this.$set(this.form, 'senderFixed', item.fixedPhone);
      this.$set(this.form, 'selectSenderAera', [item.province,item.city,item.county]);
    },

  },
};
</script>

<style lang="scss" scoped>
.header {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 10px 20px;
  height: 60px;
  background: #fff;

  // position: fixed;
  // left: 0;
  // top: 0;
  // z-index: 100;
  .header_left {
    display: flex;
    align-items: center;
    font-size: 22px;
    color: #333;

    img {
      width: 50px;
      height: 50px;
      margin-right: 10px;
    }
  }

  .header_right {
    display: flex;
    align-items: center;

    .login {
      font-size: 16px;
      font-weight: bold;
      color: #333;
      margin-right: 20px;
      cursor: pointer;
    }

    .tel {
      font-size: 16px;
      text-align: center;
      color: red;
    }
  }
}

.content {
  width: 1290px;
  margin: 0 auto;
  position: relative;
  z-index: 100;
  margin-top: -193px;
  // .tabs {
  //   width: 300px;
  //   flex-shrink: 0;
  //   margin-right: 20px;

  //   .tabs_item {
  //     cursor: pointer;
  //     width: 100%;
  //     box-sizing: border-box;
  //     padding: 20px;
  //     border-right: 4px solid #f6f6f6;
  //     font-size: 16px;
  //     font-weight: 400;
  //     color: #333;
  //   }

  //   .tabs_active {
  //     background: #f6f6f6 !important;
  //     border-right: 4px solid rgb(185, 25, 43) !important;
  //     color: rgb(185, 25, 43) !important;
  //   }
  // }
  .content_title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 25px;
    color: #fff;

    .content_title_left {
      font-size: 22px;
      font-weight: 600;
    }

    .content_title_right {
      font-size: 14px;
      line-height: 32px;

      div {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      span {
        display: inline-block;
        width: 80px;
        height: 32px;
        background: #FF8A00;
        border-radius: 4px;
        text-align: center;
        line-height: 32px;
        font-size: 12px;
        color: #fff;
        font-weight: 600;
        margin: 0 10px;
        user-select: none;
        cursor: pointer;
      }
    }
  }

  .tab_content {
    background: linear-gradient(155deg, #FFFFFF 0%, #FFFFFF 90%, rgba(255, 255, 255, 0.86) 100%);
    box-shadow: 0px 2px 60px 0px rgba(0, 0, 0, 0.04);
    box-sizing: border-box;
    padding: 32px 30px;

    .form_data {

      .form_title {
        background: rgba($color: #FF8A00, $alpha: 0.08);
        height: 48px;
        display: flex;
        align-items: center;
        margin-bottom: 36px;

        .form_title_icon {
          width: 48px;
          height: 48px;
          margin-right: 15px;
        }

        .form_title_text {
          font-size: 18px;
          color: #333;
          font-weight: 600;
        }

        // font-size: 20px;
        // color: #000;
        // border-left: 5px solid #0081cc;
        // padding-left: 20px;
        // margin-bottom: 20px;
      }

      .form_title_box {
        background: rgba($color: #FF8A00, $alpha: 0.08);
        height: 48px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        margin-bottom: 36px;

        .form_title_left {
          display: flex;
          align-items: center;

          .form_title_icon {
            width: 48px;
            height: 48px;
            margin-right: 15px;
          }

          .form_title_text {
            font-size: 18px;
            color: #333;
            font-weight: 600;
            margin-right: 26px;
          }
          ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
            color: #FF8A00;
          }
          ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner{
            background-color:#FF8A00;
            border-color:#FF8A00;
          }
          ::v-deep .el-checkbox__inner{
            border-radius: 50%;
            border-color:#FF8A00;
            &::after{
              left: 5px;
            }
          }
        }
        .form_title_right {
          display: flex;
          align-items: center;
          .form_title_btn{
            width: 111px;
            height: 30px;
            background: #FF8A00;
            border-radius: 2px;
            display: flex;
            align-items: center;
            justify-content: center;
            font-size: 14px;
            color: #fff;
            font-weight: 500;
            margin-right: 11px;
            cursor: pointer;
            user-select: none;

            img {
              width: 12px;
              height: 14px;
              margin-right: 3px;
            }
          }

        }
        .form_title_btn_list{
          display: flex;
          align-items: center;
          .form_title_btn{
            width: 80px;
            height: 32px;
            display: flex;
            align-items: center;
            justify-content: center;
            border-radius: 4px;
            border: 1px solid #FF8A00;
            background: #fff;
            font-size: 12px;
            font-weight: 600;
            cursor: pointer;
            user-select: none;
          }
        }
      }
    }
  }

  .search_content {
    box-sizing: border-box;
    padding: 20px 40px;

    .search_box {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 40px;
    }

    .destination {
      display: flex;
      align-items: center;
      font-size: 16px;
      color: #333;
      margin-bottom: 40px;

      img {
        width: 30px;
        height: 30px;
        margin: 0 10px;
      }
    }

    .timeline_item {
      // display: flex;
      // align-items: center;
      font-size: 16px;
      color: #333;

      .timeline_item_time {
        width: 300px;
        margin-right: 40px;
        margin-bottom: 20px;
        font-size: 14px;
        color: #ccc;
      }

      .timeline_item_content {
        font-size: 14px;
        color: #333;
      }
    }

    .el-timeline {
      padding-left: 0;
    }
  }
}

.bottom_btn {
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
  .bottom_btn_item{
    background: #FF8A00;
    color: #fff;
    border-radius: 4px;
    border-color: transparent;
    width: 160px;
    height: 50px;
    font-size: 20px;
    font-family: PingFangSC;
  }

}
.check_box{
  font-size: 14px;
  span{
    color: #FF8A00;
    cursor: pointer;
    user-select: none;
  }
  ::v-deep .el-checkbox__input.is-checked+.el-checkbox__label{
    color: #333;
  }
  ::v-deep .el-checkbox__input.is-checked .el-checkbox__inner{
    background-color: #FF8A00;
    border-color:#FF8A00;
  }
}
</style>